import { useState } from 'react'
import './LandingView.css'

interface LandingViewProps {
  startCallback: () => void
}

/*
  reference
  <h2 className='font-medium'>
    <span className="text-[43px] leading-[50px]">HOSPITAL</span>
    <br />
    <span className="text-[53px] leading-[50px]">MYSTERIES</span>
  </h2>

  public\images\whatdunnit_logo.svg
*/

export default function LandingView (props: LandingViewProps) {
  const [animationClass, setAnimationClass] = useState('animation-fadeIn')

  function startClicked () {
    setAnimationClass('animation-leave')
    props.startCallback()
  }

  return (
    <div className='w-full flex-center flex-col h-body'>
      <div className={`w-[300px] mx-auto text-white text-center font-museo-round ${animationClass}`}>
        <img src='/images/What_dunnit_logo.svg'
             className='object-contain mx-auto w-full xs:w-10/12 short:w-10/12'
             alt='Hospital' />
        <img src='/images/Shield.svg'
             className='object-contain mx-auto my-[30px] w-full xs:hidden short:w-10/12'
             alt='Hospital' />
        <button className='btn--blue xs:mt-[30px] short:mw-160 short:mh-40' onClick={startClicked}>START</button>
      </div>

      <p
        className={`text-sm text-primary-blue whitespace-nowrap xs:whitespace-normal xs:p-3 text-center ${animationClass}`}>
        This is a POC and should only be used on Chrome
      </p>
    </div>
  )
}
